/** @jsx jsx */
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { getAriaKeyshortcuts, redo as redoKeymap, tooltip, ToolTipContent, undo as undoKeymap } from '@atlaskit/editor-common/keymaps';
import { undoRedoMessages } from '@atlaskit/editor-common/messages';
import { buttonGroupStyle, separatorStyles } from '@atlaskit/editor-common/styles';
import { TOOLBAR_BUTTON, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import RedoIcon from '@atlaskit/icon/glyph/redo';
import UndoIcon from '@atlaskit/icon/glyph/undo';
import { redoFromToolbar, undoFromToolbar } from '../../commands';
var closeTypeAheadAndRunCommand = function closeTypeAheadAndRunCommand(editorView, api) {
  return function (command) {
    var _api$typeAhead;
    if (!editorView) {
      return;
    }
    if (api !== null && api !== void 0 && (_api$typeAhead = api.typeAhead) !== null && _api$typeAhead !== void 0 && (_api$typeAhead = _api$typeAhead.actions) !== null && _api$typeAhead !== void 0 && _api$typeAhead.isOpen(editorView.state)) {
      var _api$typeAhead2;
      api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 || (_api$typeAhead2 = _api$typeAhead2.actions) === null || _api$typeAhead2 === void 0 || _api$typeAhead2.close({
        attachCommand: command,
        insertCurrentQueryAsRawText: false
      });
    } else {
      command(editorView.state, editorView.dispatch);
    }
  };
};
var forceFocus = function forceFocus(editorView, api) {
  return function (command) {
    closeTypeAheadAndRunCommand(editorView, api)(command);
    if (!editorView.hasFocus()) {
      editorView.focus();
    }
  };
};
export var ToolbarUndoRedo = function ToolbarUndoRedo(_ref) {
  var disabled = _ref.disabled,
    isReducedSpacing = _ref.isReducedSpacing,
    editorView = _ref.editorView,
    api = _ref.api,
    formatMessage = _ref.intl.formatMessage;
  var _useSharedPluginState = useSharedPluginState(api, ['history']),
    historyState = _useSharedPluginState.historyState;
  var handleUndo = function handleUndo() {
    forceFocus(editorView, api)(undoFromToolbar);
  };
  var handleRedo = function handleRedo() {
    forceFocus(editorView, api)(redoFromToolbar);
  };
  var labelUndo = formatMessage(undoRedoMessages.undo);
  var labelRedo = formatMessage(undoRedoMessages.redo);
  var _ref2 = historyState !== null && historyState !== void 0 ? historyState : {},
    canUndo = _ref2.canUndo,
    canRedo = _ref2.canRedo;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    jsx("span", {
      css: buttonGroupStyle
    }, jsx(ToolbarButton, {
      buttonId: TOOLBAR_BUTTON.UNDO,
      spacing: isReducedSpacing ? 'none' : 'default',
      onClick: handleUndo,
      disabled: !canUndo || disabled,
      "aria-label": tooltip(undoKeymap, labelUndo),
      "aria-keyshortcuts": getAriaKeyshortcuts(undoKeymap),
      title: jsx(ToolTipContent, {
        description: labelUndo,
        keymap: undoKeymap
      }),
      iconBefore: jsx(UndoIcon, {
        label: ""
      }),
      testId: "ak-editor-toolbar-button-undo"
    }), jsx(ToolbarButton, {
      spacing: isReducedSpacing ? 'none' : 'default',
      buttonId: TOOLBAR_BUTTON.REDO,
      onClick: handleRedo,
      disabled: !canRedo || disabled,
      title: jsx(ToolTipContent, {
        description: labelRedo,
        keymap: redoKeymap
      }),
      iconBefore: jsx(RedoIcon, {
        label: ""
      }),
      testId: "ak-editor-toolbar-button-redo",
      "aria-label": tooltip(redoKeymap, labelRedo),
      "aria-keyshortcuts": getAriaKeyshortcuts(redoKeymap)
    }), jsx("span", {
      css: separatorStyles
    }))
  );
};
export default injectIntl(ToolbarUndoRedo);